import { render, staticRenderFns } from "./CustomerStatusForm.vue?vue&type=template&id=b2ab19ce"
import script from "./CustomerStatusForm.vue?vue&type=script&lang=js"
export * from "./CustomerStatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports